<template>
  <DuncePlaceholder msg="Donald Trump is a Fucking Dunce"/>

  <TimeUntil
    event="This Nightmare is Over... God Willing"
    year=2029
    month=1
    day=20
  />

  <TimeSince
    event="Inauguration Day"
    year=2025
    month=1
    day=20
  />

  <TimeSince
    event="The Pardon of Everyone Who Attacked the Capitol on January 6th 2020"
    year=2025
    month=1
    day=20
  />

  <TimeSince
    event="The Arrest and Detention of Permanent Resident Mahmoud Khalil by I.C.E"
    year=2025
    month=2
    day=20
  />

  <TimeSince
    event="J.D Vance Berates our ally Ukraine in the Oval Office"
    year=2025
    month=2
    day=28
  />

  <TimeSince
    event="Kilmar Armando Abrego Garcia illegally sent to El Salvador"
    year=2025
    month=3
    day=8
  />

  <TimeSince
    event="Israel-Gaza Ceasefire Shattered by Israeli Suprise Attack"
    year=2025
    month=3
    day=18
  />

  <TimeSince
    event="Charges Against Corrupt Mayor Eric Adams Dropped By Trumps DOJ After Multiple Prosecutors Resigned"
    year=2025
    month=4
    day=2
  />

  <TimeSince
    event="The Liberation Day Recriprocol Tariffs Announced"
    year=2025
    month=4
    day=2
  />

  <TimeSince
    event="The Rollback of The Liberation Day Recriprocol Tariffs"
    year=2025
    month=4
    day=9
  />

  <TimeSince
    event="The Supreme Court ruled that the Government facilitate the return Abrego Garcia"
    year=2025
    month=4
    day=10
  />

  <TimeSince
    event="The Trump Administration Formally Accepts $400 Million Jet 'Gifted' to the President"
    year=2025
    month=5
    day=21
  />

  <TimeSince
    event="The President Attempted to Revoke Harvards ability to Enroll International Students"
    year=2025
    month=5
    day=22
  />

  <TimeSince
    event="The President Banned travel into the US from 'Muslim' Nations"
    year=2025
    month=6
    day=4
  />

  <TimeSince
    event="Kilmar Armando Abrego Garcia Arrives back in the United States"
    year=2025
    month=6
    day=6
  />

  <TimeSince
    event="The President Illegally Sends 4000 National Guard Members to Los Angeles in Unnecessary Response to Protests"
    year=2025
    month=6
    day=7
  />

  <TimeSince
    event="The President Sends 200 Active Duty Marines to Los Angeles in Response to Protests"
    year=2025
    month=6
    day=10
  />

  <TimeSince
    event="Senator Alex Padilla Taken Down and Hand-Cuffed by Federal Agents at Kristi Noam Press Conference"
    year=2025
    month=6
    day=12
  />

  <TimeSince
    event="The President Increases the Number of Active Duty Marines Deployed to Los Angeles to 700 in Response to Protests"
    year=2025
    month=6
    day=13
  />

  <TimeSince
    event="The President Holds a Military Parade in D.C on His Birthday"
    year=2025
    month=6
    day=14
  />

  <TimeSince
    event="The President Fired the Head of the Department of Labor Statistics Because He Didn't Like The Jobs Report"
    year=2025
    month=8
    day=1
  />

  <TimeSince
    event="The President deploys the National Guard to DC and Takes over DC's Police Department, declaring a emergency while crime in DC is at a 30 year low."
    year=2025
    month=8
    day=11
  />

  <TimeSince
    event="The US Military attacks Venezuela and kidnaps the dictator president Nicolas Maduro"
    year=2026
    month=1
    day=3
  />

  <TimeSince
    event="ICE Murders American Citizen Renee Nicole Good in Minneapolis; The Administration claims he's a 'domestic terrorist' without evidence"
    year=2026
    month=1
    day=7
  />

  <TimeSince
    event="ICE Murders American Citizen Alex Pretti in Minneapolis; The Administration claims he's a 'domestic terrorist' without evidence"
    year=2026
    month=1
    day=25
  />

  <TimeSince
    event="ICE Agents Use False Pretenses to Enter Columbia University Housing and Detain Student Ellie Aghayeva"
    year=2026
    month=2
    day=26
  />

  <TimeSince
    event="The US and Israel Launch Surprise Airstrikes on Iran Without Congressional Authorization, Assassinating Supreme Leader Khamenei and Killing Over 1,350 Civilians"
    year=2026
    month=2
    day=28
  />

  <TimeSince
    event="The President Threatens to Destroy Every Bridge and Power Plant in Iran, Posting 'A Whole Civilization Will Die Tonight' on Truth Social"
    year=2026
    month=4
    day=6
  />

</template>

<script>
import DuncePlaceholder from './components/DuncePlaceholder.vue'
import TimeSince from './components/TimeSince.vue'
import TimeUntil from './components/TimeUntil.vue'

export default {
  name: 'App',
  components: {
    DuncePlaceholder,
    TimeSince,
    TimeUntil
  }
}
</script>

<style>
body {
  background-color: black;
}
#app {
  font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter", monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.event {
  color: grey
}
.since {
  color: white;
  font-size: 1.5rem;
}
.until {
  color: white;
  font-size: 1.75rem;
}
</style>
